/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type twitterAccessTokenQueryVariables = {
    readonly oauthToken: string;
    readonly oauthVerifier: string;
};
export type twitterAccessTokenQueryResponse = {
    readonly twitterUser: {
        readonly hasErrors: boolean | null;
        readonly errors: ReadonlyArray<{
            readonly created: unknown | null;
            readonly id: string;
            readonly location: string | null;
            readonly type: string | null;
        } | null> | null;
        readonly twitterUser: {
            readonly id: string;
            readonly twitterUserId: string | null;
            readonly openIdToken: string | null;
        } | null;
    } | null;
};
export type twitterAccessTokenQuery = {
    readonly response: twitterAccessTokenQueryResponse;
    readonly variables: twitterAccessTokenQueryVariables;
};



/*
query twitterAccessTokenQuery(
  $oauthToken: String!
  $oauthVerifier: String!
) {
  twitterUser(oauthToken: $oauthToken, oauthVerifier: $oauthVerifier) {
    hasErrors
    errors {
      created
      id
      location
      type
    }
    twitterUser {
      id
      twitterUserId
      openIdToken
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "oauthToken",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "oauthVerifier",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "twitterUser",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "oauthToken",
        "variableName": "oauthToken"
      },
      {
        "kind": "Variable",
        "name": "oauthVerifier",
        "variableName": "oauthVerifier"
      }
    ],
    "concreteType": "TwitterUserPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "hasErrors",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "errors",
        "storageKey": null,
        "args": null,
        "concreteType": "Error",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "created",
            "args": null,
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "location",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "type",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "twitterUser",
        "storageKey": null,
        "args": null,
        "concreteType": "TwitterUser",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "twitterUserId",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "openIdToken",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "twitterAccessTokenQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "twitterAccessTokenQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "twitterAccessTokenQuery",
    "id": null,
    "text": "query twitterAccessTokenQuery(\n  $oauthToken: String!\n  $oauthVerifier: String!\n) {\n  twitterUser(oauthToken: $oauthToken, oauthVerifier: $oauthVerifier) {\n    hasErrors\n    errors {\n      created\n      id\n      location\n      type\n    }\n    twitterUser {\n      id\n      twitterUserId\n      openIdToken\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '315c4ef350b4447bec0259f7da4fbb3f';
export default node;
